import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFeestdag = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Feestdag_svg__a)">
      <mask
        id="Feestdag_svg__b"
        width={10}
        height={16}
        x={8}
        y={16}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M18 21.37a5 5 0 1 0-6.58 4.74L11 27.37h1.5v2a2.5 2.5 0 0 0 2.5 2.5v-1a1.5 1.5 0 0 1-1.5-1.5v-2H15l-.42-1.26A5 5 0 0 0 18 21.37"
        />
      </mask>
      <g mask="url(#Feestdag_svg__b)">
        <path
          fill="#F18700"
          d="M17.52 17.37 5.27 10.29l7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m-1.8 22.54 7.07-12.25 12.25 7.08z"
        />
        <path
          fill="#F7A941"
          d="m12.34-1.95 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m17.52 17.37 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m22.7 36.69-12.25-7.08 7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m-1.8 22.54 12.25 7.07-7.07 12.25zM3.38 41.86l7.07-12.25 12.25 7.08z"
        />
        <path
          fill="#F18700"
          d="m17.52 17.37-7.07 12.24-12.25-7.07zM17.52 17.37l12.25 7.07-7.07 12.25zM36.84 12.19l-7.07 12.25-12.25-7.07z"
        />
      </g>
      <mask
        id="Feestdag_svg__c"
        width={18}
        height={26}
        x={14}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M32 16.37a9 9 0 1 0-11.24 8.72L20 27.37h2.44v1.76a3.5 3.5 0 0 0 3.5 3.5v-1a2.5 2.5 0 0 1-2.5-2.5v-1.76H26l-.76-2.28A9 9 0 0 0 32 16.37"
        />
      </mask>
      <g mask="url(#Feestdag_svg__c)">
        <path
          fill="#FED27A"
          d="M27.18 14.72 14.93 7.64 22-4.6zM2.68.57l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="m7.86 19.89 7.07-12.25 12.25 7.08zM22-4.6 14.93 7.64 2.68.57z"
        />
        <path
          fill="#F7A941"
          d="m7.86 19.89 12.25 7.07-7.08 12.25zM32.35 34.03l-12.24-7.07 7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m27.18 14.72-7.07 12.24-12.25-7.07zM13.03 39.21l7.08-12.25 12.24 7.07zM22-4.6l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="m27.18 14.72 7.07-12.25 12.24 7.07zM27.18 14.72l12.24 7.07-7.07 12.24z"
        />
        <path
          fill="#FED27A"
          d="m46.49 9.54-7.07 12.25-12.24-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Feestdag_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFeestdag);

export default ForwardRef;
